import { gql } from 'apollo-angular';

export const RemoveTeamMemberDocument = gql`
  mutation removeTeamMember($id: Int!) {
    removeTeamMember(id: $id)
  }
`;
